import {RELATIVE_API_URL} from 'config';

export default {
    GET_SORT_CONFIG: `${RELATIVE_API_URL}/lineup-tool/sport-config`,
    GET_SLATE: `${RELATIVE_API_URL}/lineup-tool/slate`,
    GET_SLATES: `${RELATIVE_API_URL}/lineup-tool/slates`,
    VALIDATE_CONDITIONS: `${RELATIVE_API_URL}/lineup-tool/validate-conditions`,
    DOWNLOAD_LINEUPS: `${RELATIVE_API_URL}/lineup-tool/download-lineups`,
    RESOLVE_LINEUP: `/resolve-lineup`,
    RESOLVE_LINEUP_V2: `/resolve-lineup/v2`,
    RESOLVE_LINEUP_V3: `/resolve-lineup/v3`,
    RESOLVE_PLAYERS: `${RELATIVE_API_URL}/late-swap/resolve-players`,
    GET_MESSAGES: `${RELATIVE_API_URL}/message/get-global`,
    GET_SPORT_MESSAGES: `${RELATIVE_API_URL}/message/get-sport`,
};
